import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import { useNavigate } from "react-router-dom";
import { BrowserAuthError } from "@azure/msal-browser";

const LoginForm = () => {
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleMicrosoftSignIn = async () => {
    // Prevent multiple login attempts
    if (isLoggingIn) return;
    
    setIsLoggingIn(true);
    
    try {
      // Check if there's an interaction in progress
      if (instance.getActiveAccount()) {
        // If there's already an active account, try to use it
        navigate("/dashboard");
        return;
      }
      
      const clientInfo = {
        ip: window.location.hostname,
        userAgent: navigator.userAgent,
      };
      
      await instance.loginRedirect({
        ...loginRequest,
        extraQueryParameters: {
          client_info: JSON.stringify(clientInfo)
        }
      });
    } catch (e) {
      // Handle the specific interaction_in_progress error
      if (e instanceof BrowserAuthError && e.errorCode === "interaction_in_progress") {
        console.log("Login already in progress, waiting for completion");
        // The redirect will happen automatically when the interaction completes
      } else {
        console.error("Login failed", e);
        setIsLoggingIn(false);
      }
    }
  };

  useEffect(() => {
    // Reset login state when component mounts
    setIsLoggingIn(false);
    
    // Check if user is already logged in
    if (accounts.length > 0) {
      navigate("/dashboard");
    }
    
    // Handle the case where a redirect is happening
    const handleRedirectPromise = async () => {
      try {
        await instance.handleRedirectPromise();
      } catch (error) {
        console.error("Error handling redirect:", error);
      }
    };
    
    handleRedirectPromise();
  }, [accounts, navigate, instance]);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="text-center mb-4">
                <h2>Login</h2>
                <p>Access your account securely</p>
              </div>
              <button
                onClick={handleMicrosoftSignIn}
                className="btn btn-light w-100 d-flex align-items-center justify-content-center"
                style={{ height: "41px", border: "1px solid #8C8C8C" }}
                disabled={isLoggingIn}
              >
                <img
                  src="https://docs.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_mssymbol_19.png"
                  alt="Microsoft logo"
                  style={{ height: "21px", marginRight: "10px" }}
                />
                {isLoggingIn ? "Signing in..." : "Sign in with Microsoft"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
